export function transform(props) {
    // Adds leading zero
    Object.entries(props).forEach(([key, value]) => {
        let digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
    });
    return props;
} 